export default "__VITE_ASSET__c911f8d7__"